<!-- 項目外框 -->
<template>
  <div class="box">
    <base-title :class="required?'required':''" v-html="title" ></base-title>
    <v-divider v-if="title"></v-divider>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'base-box',
  props: {
    title: String,
    required: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="stylus" scoped>

.box
  text-align left
  padding 30px
  background-color #fff
  .title
    padding 0px
.box+.box
  margin-top 30px
hr
  margin 20px 0
</style>
